const card = {
  cvMatch: true,
}

export default card
